export default {"src":"/_next/static/media/panoramic-icon.b39161f4.svg","height":45,"width":66,"blurWidth":0,"blurHeight":0};